<template>
<el-table :data="list" highlight-current-row height="500">
    <el-table-column prop="code" label="Código"></el-table-column>
    <el-table-column prop="birthday" label="Identificación">
        <template #default="scope">
            <div class="">
                <span>{{scope.row.docName}}</span><br>
                <span>{{scope.row.docnumber}}</span>
            </div>
        </template>
    </el-table-column>
    <el-table-column label="Participante" width="250">
        <template #default="scope">
            <div class="d-flex align-items-center">
                <div class="symbol symbol-40 symbol-light-success mr-3">
                    <el-avatar shape="square" size="large" fit="contain" :src="scope.row.photo" :class="'border-success'"></el-avatar>
                </div>
                <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                    <span>{{scope.row.firstname}} </span><br>
                    <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                </div>
            </div>
        </template>
    </el-table-column>

    <el-table-column prop="age" label="Edad">
    </el-table-column>
    <el-table-column prop="birthday" label="Fecha Nacimiento">
        <template #default="scope">
            <span>{{$moment(scope.row.birthday).format("DD/MM/YYYY")}}</span>
        </template>
    </el-table-column>
    <el-table-column label="Estado">
        <template #default="scope">
            <span class="badge badge-light-success" v-if="scope.row.mstatus == 1">Activo</span>
            <span class="badge badge-light-warning" v-if="scope.row.mstatus == 2">Baja temporal</span>
            <span class="badge badge-light-danger" v-if="scope.row.mstatus == 3">Baja definitiva</span>
        </template>
    </el-table-column>
    <el-table-column label="Opciones">
        <template #default="scope">
            <div class="options" v-if="!selection">
                <!--<span class="svg-icon svg-icon-primary svg-icon-2x mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
                            <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
                            <rect fill="#000000" opacity="0.3" x="10" y="9" width="7" height="2" rx="1" />
                            <rect fill="#000000" opacity="0.3" x="7" y="9" width="2" height="2" rx="1" />
                            <rect fill="#000000" opacity="0.3" x="7" y="13" width="2" height="2" rx="1" />
                            <rect fill="#000000" opacity="0.3" x="10" y="13" width="7" height="2" rx="1" />
                            <rect fill="#000000" opacity="0.3" x="7" y="17" width="2" height="2" rx="1" />
                            <rect fill="#000000" opacity="0.3" x="10" y="17" width="7" height="2" rx="1" />
                        </g>
                    </svg>
                </span>-->

                <span class="svg-icon svg-icon-primary svg-icon-2x mr-2" @click="onEditItem(scope.row)">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <path d="M12.2674799,18.2323597 L12.0084872,5.45852451 C12.0004303,5.06114792 12.1504154,4.6768183 12.4255037,4.38993949 L15.0030167,1.70195304 L17.5910752,4.40093695 C17.8599071,4.6812911 18.0095067,5.05499603 18.0083938,5.44341307 L17.9718262,18.2062508 C17.9694575,19.0329966 17.2985816,19.701953 16.4718324,19.701953 L13.7671717,19.701953 C12.9505952,19.701953 12.2840328,19.0487684 12.2674799,18.2323597 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.701953, 10.701953) rotate(-135.000000) translate(-14.701953, -10.701953) " />
                            <path d="M12.9,2 C13.4522847,2 13.9,2.44771525 13.9,3 C13.9,3.55228475 13.4522847,4 12.9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,6 C2,3.790861 3.790861,2 6,2 L12.9,2 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                        </g>
                    </svg>
                </span>

                <span class="svg-icon svg-icon-primary svg-icon-2x" @click="deleteItem(scope.row)">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <rect x="0" y="0" width="24" height="24" />
                            <path d="M6,8 L18,8 L17.106535,19.6150447 C17.04642,20.3965405 16.3947578,21 15.6109533,21 L8.38904671,21 C7.60524225,21 6.95358004,20.3965405 6.89346498,19.6150447 L6,8 Z M8,10 L8.45438229,14.0894406 L15.5517885,14.0339036 L16,10 L8,10 Z" fill="#000000" fill-rule="nonzero" />
                            <path d="M14,4.5 L14,3.5 C14,3.22385763 13.7761424,3 13.5,3 L10.5,3 C10.2238576,3 10,3.22385763 10,3.5 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3" />
                        </g>
                    </svg>
                </span>
            </div>

            <el-button v-else type="success" size="small" icon="el-icon-check" plain @click="setSelection(scope.row)"></el-button>

        </template>
    </el-table-column>
    

</el-table>
</template>

<script>
//utils
import code from "@/core/config/error";

//services
import payrollService from "@/core/services/payroll.service"

//loader
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
    props: {
        selection: {
            require: true,
            type: Boolean,
            default: false,
        },
        list: {
            require: true,
            type: Array,
            default: [],
        }
    },
    methods: {
        setSelection(data) {
            this.$emit("getSelection", data);
        },
        deleteItem(data) {
            this.$confirm('Desea eliminar el registro de ' + data.firstname + '?', 'Aviso', {
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                this.onDelete(data)
            })
        },
        async onEditItem(data) {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await payrollService.editItem(data).then((res) => {
                //console.log(res.data)
                this.$emit("onAddEdditDialog", res.data)
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(err.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        async onDelete(data) {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await payrollService.deleteItem(data).then((res) => {
                if (res.data.status)
                    this.$emit("reload")
                else
                    this.$alert(res.data.message, 'Aviso',{type: 'error'})
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(err.response)
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    }

}
</script>
